export default {"src":"/_next/static/media/close.38c1b3a8.svg","height":20,"width":20};